<template>
	<div class="alert alert-dismissible text-center rounded-0 fade" :class="[alert.show, 'alert-' + alert.type]" role="alert" id="alert-box">
		<p class="mb-0">
			<strong v-if="alert.type == 'warning'">{{__('lang.kwl.alert.warning')}}:</strong> 
			<strong v-else-if="alert.type == 'danger'">{{__('lang.kwl.alert.error')}}:</strong> 
			<strong v-else-if="alert.type == 'info'">{{__('lang.kwl.alert.info')}}:</strong> 
			<strong v-else-if="alert.type == 'success'">{{__('lang.kwl.alert.success')}}:</strong> 
			{{ alert.message }}
		</p>
		<button type="button" class="close" @click="$store.dispatch('alert/resetState')" aria-label="Close"> <!-- data-dismiss="alert" -->
	   		<span aria-hidden="true">
		  		<svg class="icon icon-xs">
		    		<use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
		  		</svg>
			</span>
		</button>
	</div>
</template>

<script>
//import log from './services/logger/index'

  export default {
    data() {
      	return {
      		alert: {
          		show: 'd-none', //show || d-none
          		type: '', //warning danger info success
          		message: '',
				time:5000,
      		}
    	}
    },
	methods: {
		timeout() {
			this.$store.dispatch('alert/resetState'); 

		}
	},
    computed: {
    	alertStore: {
    		get () {
    			return this.$store.state.alert.value
    		},
		    set (value) {
  		      	this.$store.commit('validation/updateAlert', value)
  		    }
    	},
    },
    watch: {
    	alertStore:{
			deep:true,
			handler (){
				this.alert = this.alertStore
				if(this.alert.show == 'show') {
				    setTimeout(this.timeout, this.alert.time);
				}
			},
		},
    },
	mounted() {

	}
  }
</script>